export default __webpack_public_path__ + "cebcdbff2f8fc50a695fd7d3a7add24e.png";